export const UPDATE_LOGO_REQUEST = 'UPDATE_LOGO_REQUEST';
export const UPDATE_LOGO_SUCCESS = 'UPDATE_LOGO_SUCCESS';
export const UPDATE_LOGO_FAILURE = 'UPDATE_LOGO_FAILURE';